import React from "react";

const Select = (props) => {
  const {
    id,
    value,
    children,
    className,
    defaultText,
    onChange,
    required,
    label,
    disabled = false,
    defaultIsHidden = false,
  } = props;

  return (
    <div>
      {label === null || label === "" || label === undefined ? (
        <></>
      ) : (
        <label
          htmlFor={"select" + id}
          className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
        >
          {label}
        </label>
      )}
      <select
        id={"select" + id}
        required={required}
        value={value || ""}
        disabled={disabled ?? false}
        onChange={onChange}
        className={`mb-6 block w-full rounded-lg border border-gray-300 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500 
        ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : ""
        } 
        ${className}`}
      >
        {!defaultIsHidden && <option value="">{defaultText}</option>}
        {children}
      </select>
    </div>
  );
};

export default Select;
